/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import types from "./helpers/types";

let reactPlugin = null;
let appInsights = null;

/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: Object, initialize: Function}} - Object
 */
const createTelemetryService = () => {
  /**
   * Initialize the Application Insights class
   * @param {string} instrumentationKey - Application Insights Instrumentation Key
   * @param {Object} browserHistory - client's browser history, supplied by the withRouter HOC
   * @return {void}
   */
  const initialize = (instrumentationKey, browserHistory) => {
    if (!browserHistory) {
      throw new Error("Could not initialize Telemetry Service");
    }
    if (!instrumentationKey) {
      throw new Error(
        "Instrumentation key not provided in ./src/telemetry-provider.jsx"
      );
    }

    reactPlugin = new ReactPlugin();

    appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: instrumentationKey,
        maxBatchInterval: 0,
        disableFetchTracking: false,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: {
            history: browserHistory,
          },
        },
      },
    });
    appInsights.loadAppInsights();
  };

  return { reactPlugin, appInsights, initialize };
};

export const setUserContext = (goTrackUser) => {
  if (appInsights) {
    var email = goTrackUser.email;
    var userRole = goTrackUser.roles[0];
    // 'storeCookie' parameter set to 'true' to track all user session events
    appInsights.setAuthenticatedUserContext(email, null, true);
    const telemetryInitializer = (envelope) => {
      envelope.data.role = types.goTrackUserRolesDescription[userRole];
    };
    appInsights.addTelemetryInitializer(telemetryInitializer);
  }
};

export const clearUserContext = () => {
  if (appInsights) {
    appInsights.clearAuthenticatedUserContext();
  }
};

export const ai = createTelemetryService();
export const getAppInsights = () => appInsights;
